import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { Star } from '@material-ui/icons';
import { IRatingNotification, RatingType } from '../interfaces';
import { useUpdateRatingNotification } from '../hooks';
import SavePartnerRatingDialog from './Partner/SaveRatingDialog';
import SavePersonalRatingDialog from './Personal/SaveRatingDialog';
import SavePartnerUgoRatingDialog from './PartnerUgo/SaveRatingDialog';

interface IProps extends DialogProps {
  ratingNotification: IRatingNotification;
  disabled: boolean;
  onCheckRating(): void;
}

const CheckRatingDialog = ({
  ratingNotification: { defectActUgo, partners, personal },
  disabled: _disabled,
  onCheckRating,
  ...props
}: IProps) => {
  // Local state
  const [ratingDialogOpened, setRatingDialogOpened] = useState<RatingType | null>(null);

  const { updateNotification, loading: updateNotificationLoading } = useUpdateRatingNotification(onCheckRating);
  const disabled = _disabled || updateNotificationLoading;

  return (
    <Dialog {...props} fullWidth maxWidth="sm" scroll="body">
      <DialogTitle>
        <b>Оценка</b>
      </DialogTitle>

      <DialogContent dividers style={{ padding: 0 }}>
        <List disablePadding>
          {Boolean(defectActUgo.list.length) && (
            <ListItem divider style={{ flexDirection: 'column', alignItems: 'stretch' }}>
              <ListItemText primary={<b>Партнеры УГО</b>} secondary={defectActUgo.message} />

              <Button
                startIcon={<Star />}
                size="small"
                variant="outlined"
                color="primary"
                style={{ alignSelf: 'flex-end' }}
                disabled={disabled}
                onClick={() => setRatingDialogOpened('partner-ugo')}
              >
                Приступить к оценке
              </Button>

              <SavePartnerUgoRatingDialog
                open={ratingDialogOpened === 'partner-ugo'}
                partners={defectActUgo.list}
                onClose={() => setRatingDialogOpened(null)}
                onSaveRating={onCheckRating}
              />
            </ListItem>
          )}

          {Boolean(partners.message) && (
            <ListItem divider style={{ flexDirection: 'column', alignItems: 'stretch' }}>
              <ListItemText primary={<b>Партнеры</b>} secondary={partners.message} />

              {Boolean(partners.list.length) && (
                <Button
                  startIcon={<Star />}
                  size="small"
                  variant="outlined"
                  color="primary"
                  style={{ alignSelf: 'flex-end' }}
                  disabled={disabled}
                  onClick={() => setRatingDialogOpened('partner')}
                >
                  Приступить к оценке
                </Button>
              )}

              <SavePartnerRatingDialog
                open={ratingDialogOpened === 'partner'}
                partners={partners.list}
                onClose={() => setRatingDialogOpened(null)}
                onSaveRating={onCheckRating}
              />
            </ListItem>
          )}

          {Boolean(personal.list.length) && (
            <ListItem divider style={{ flexDirection: 'column', alignItems: 'stretch' }}>
              <ListItemText primary={<b>Персонал</b>} secondary={personal.message} />

              <Button
                startIcon={<Star />}
                size="small"
                variant="outlined"
                color="primary"
                style={{ alignSelf: 'flex-end' }}
                disabled={disabled}
                onClick={() => setRatingDialogOpened('personal')}
              >
                Приступить к оценке
              </Button>

              <SavePersonalRatingDialog
                open={ratingDialogOpened === 'personal'}
                personal={personal.list}
                onClose={() => setRatingDialogOpened(null)}
                onSaveRating={onCheckRating}
              />
            </ListItem>
          )}

          {[partners, personal].every(({ required }) => !required) && !defectActUgo.required && (
            <ListItem style={{ flexDirection: 'column' }}>
              <Button
                startIcon={<Star />}
                size="small"
                variant="outlined"
                color="primary"
                style={{ alignSelf: 'flex-end' }}
                disabled={disabled}
                onClick={() => updateNotification({ partners, personal })}
              >
                Осведомлен(-а)
              </Button>
            </ListItem>
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default CheckRatingDialog;
